// extracted by mini-css-extract-plugin
module.exports = {"wrap":"breadcrumbs_wrap__ou3CW","crumb":"breadcrumbs_crumb__1ymYP"};